module.exports = __webpack_public_path__ + "img/AIAssistant.a7430b1a.png";